export default __webpack_public_path__ + "static/media/gallery_17.bec1d356.jpg";